import { SvelteURL } from 'svelte/reactivity';
import { VERB_TABS, MAIN_TABS } from '$lib/constants';

export function isLoggedInURL(): URL {
	const searchURL = new SvelteURL('/loggedin', window.location.origin);
	return searchURL;
}

export function searchURL(verbName: string): URL {
	//const params = new SvelteURLSearchParams({ search: verbName });
	//const searchURL = `/api/verb?${params.toString()}`;

	//searchURL.searchParams.append('search', verbName);
	//return searchURL;

	const searchURL = new SvelteURL('/api/verb', window.location.origin);
	searchURL.searchParams.append('search', verbName);

	return searchURL;
}

export function allquizURL(): URL {
	const quizURL = new SvelteURL('/api/verb', window.location.origin);
	quizURL.searchParams.append(MAIN_TABS.QUIZ, 'true');

	return quizURL;
}

export function verbTabURL(verbName: string, tabID: string): string {
	return '/' + verbName + '/' + tabID;
}

export function parseMainTab(url: SvelteURL): string {
	// Define valid search parameters
	const validParams = [MAIN_TABS.HOME, MAIN_TABS.QUIZ, MAIN_TABS.ABOUT];

	try {
		const params = url.searchParams;
		const keys = Array.from(params.keys());

		// If there's not exactly one search param, return home
		let key: string, value: string;
		if (keys.length !== 1) {
			key = MAIN_TABS.HOME;
		} else {
			key = keys[0]; // string
			value = params.get(key) ?? '';
			if (value !== 'true') {
				key = MAIN_TABS.HOME;
			}
		}

		if (!validParams.includes(key)) {
			key = MAIN_TABS.HOME;
		}

		return key;
	} catch {
		// If URL parsing fails, send to home
		return MAIN_TABS.HOME;
	}
}

export function parseVerbTab(url: SvelteURL): [string, string] {
	// Define valid search parameters
	const validParams = [
		VERB_TABS.CONJUGATION,
		VERB_TABS.DEFINITION,
		VERB_TABS.USAGE,
		VERB_TABS.QUIZ
	];

	try {
		const params = url.searchParams;
		const keys = Array.from(params.keys());

		// If there's not exactly one search param, return null
		let key: string, value: string;
		if (keys.length !== 1) {
			key = VERB_TABS.CONJUGATION;
			value = '';
		} else {
			key = keys[0]; // string
			value = params.get(key) ?? '';
		}

		if (!validParams.includes(key)) {
			key = VERB_TABS.CONJUGATION;
			value = '';
		}

		return [key, value];
	} catch {
		// If URL parsing fails, return null
		return ['', ''];
	}
}
